import './section.less';
import '../theme/theme.less';

// trim-below
import {withContext} from 'recompose';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('section');
const theme = block('theme');

class BaseSection extends Component {
	render() {
		const {title, bgColor, children, summary, buttonText, pageUrl} = this.props;
		const modifiers = {};

		if (bgColor) {
			modifiers[bgColor] = true;
		}

		return (
			<div className={b({}, theme(modifiers))}>
				<div className={b('container', theme('container'))}>
					{
						title &&
						<h2 className={b('title', theme('section-title'))}>{title}</h2>
					}
					{
						summary &&
						<div className={b('summary', theme('section-summary'))}>{summary}</div>
					}
					<div className={b('placeholder')}>
						{children}
					</div>
					{
						buttonText &&
						<a href={pageUrl} className={b('button', theme('button'))}>{buttonText}</a>
					}
				</div>
			</div>
		);
	}
}

BaseSection.propTypes = {
	bgColor: PropTypes.oneOf(['white', 'gray', 'black']),
	title: PropTypes.string,
	summary: PropTypes.string,
	children: PropTypes.node.isRequired,
	buttonText: PropTypes.string,
	pageUrl: PropTypes.string
};

const enhance = withContext(
	{theme: PropTypes.func.isRequired},
	() => ({theme})
);

export default enhance(BaseSection);



// WEBPACK FOOTER //
// ./src/components/sections/base-section.jsx